<template>
  <b-modal
    v-model="reBuyModal"
    centered
    title="Санамж"
    header-class="pd-0"
    no-close-on-backdrop
  >
    <template #modal-header="{ }">
      <div class="modal-header pd-y-20 pd-x-20 pd-sm-x-30 bd-0">
        <a
          @click="$emit('on-hide')"
          role="button"
          class="close pos-absolute t-15 r-15"
          data-dismiss="modal"
          aria-label="Close"
        >
          <span aria-hidden="true">×</span>
        </a>
        <div class="media align-items-center">
          <span class="tx-color-03 d-none d-sm-block"
            ><feather type="lock" class="ht-60-f wd-60-f"></feather
          ></span>
          <div class="media-body mg-sm-l-20">
            <h4 class="tx-18 tx-sm-20 mg-b-2">Мэдэгдэл</h4>
            <p class="tx-13 tx-color-03 mg-b-0">Хандах эрхгүй.</p>
          </div>
        </div>
        <!-- media -->
      </div>
    </template>
    <div class="alert alert-warning mg-b-0" role="alert">
      <h6 class="alert-heading">Таны хувьд уг хичээл түгжээтэй байна!</h6>
      <p class="mg-b-0">
        Та уг хичээлийг нэмэлтээр сонгон судлах гэж байна. Итгэлтэй байна уу ?
      </p>
    </div>
    <template #modal-footer>
      <div class="btn-group">
        <button @click="$emit('on-hide')" class="btn btn-warning">Үгүй</button>
        <button @click="reBuyConfirmOk()" class="btn btn-success">Тийм</button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { request } from "@/api/all";
import "element-ui/lib/theme-chalk/index.css";
import { Notification } from "element-ui";

export default {
  props: {
    reBuyModal: {
      type: Boolean,
      default: () => false
    },
    reBuyObj: {
      type: Object,
      default: () => {}
    },
    course: {
      type: Object,
      default: () => {}
    },
    itemId: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      reBuySubmitModel: {}
    };
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    reBuyConfirmOk() {
      let _boxId = 0;
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Task/GetTaskBoxIdByOt" },
        params: { id: this.itemId, objectTypeId: 343 },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          if (res.data.boxes.length) {
            _boxId = res.data.boxes[0].id;

            let _projid = 0;
            let prj = this.$store.state.app.groupDefaultProjects.filter(
              x => x.objectTypeId == 343
            );
            if (prj.length > 0) {
              _projid = prj[0].id;

              this.toggleBodyClass("addClass", "dynamic-locker");
              request({
                api: { method: "GET", url: "Task/GetInherited" },
                params: {
                  id: 0,
                  projectId: _projid,
                  parentId: 0,
                  boxId: _boxId,
                  objectTypeId: 343,
                  userId: this.$store.state.user.userId,
                  force: true,
                  lmsV2: true
                },
                store: this.$store
              }).then(res => {
                this.toggleBodyClass("removeClass", "dynamic-locker");
                if (res != false) {
                  //console.log('Task/GetInherited=> ', res);
                  if (res.hasInvoice != undefined && res.hasInvoice == true) {
                    Notification.info({
                      message:
                        "Та хүсэлт илгээсэн байна. Дараах нэхэмжлэхийг төлснөөр таны хүсэлт баталгаажна.",
                      duration: 5000,
                      type: "info",
                      position: "top-right",
                      offset: 50
                    });
                    this.$router.push("/lms/paymentDetail/" + res.invoiceId);
                  } else {
                    this.reBuySubmitModel = res.data.task;
                    //console.log('reBuySubmitModel=> ', this.reBuySubmitModel, this.$store.state.user.userInfo, this.course);

                    this.reBuySubmitModel.task = this.$store.state.user.userInfo.fullName;
                    this.reBuySubmitModel.connectTaskToBox = [
                      {
                        boxObjectTypeId: 114,
                        taskIds: [this.$route.params.id],
                        name: "Сонгосон хичээлүүд"
                      }
                    ];

                    this.reBuySubmitModel.taskDesc = `${this.course.name} / ${this.reBuyObj.title}-н төлбөр. Овог ${this.$store.state.user.userInfo.ovog} Нэр: ${this.$store.state.user.userInfo.ner} Регистр: ${this.$store.state.user.userInfo.register}`;
                    this.reBuySubmitModel.thirdOrganizationTaskId = this.reBuyObj.id;
                    this.reBuySubmitModel.parentId = 0;

                    this.toggleBodyClass("addClass", "dynamic-locker");
                    request({
                      api: { method: "POST", url: "Task/PostInherited" },
                      data: { model: this.reBuySubmitModel },
                      store: this.$store
                    }).then(resInv => {
                      this.toggleBodyClass("removeClass", "dynamic-locker");
                      if (resInv != false) {
                        //console.log('resInv=> ', resInv.taskId);

                        this.toggleBodyClass("addClass", "dynamic-locker");
                        request({
                          api: {
                            method: "POST",
                            url: "Payment/PostProductAndWorkservice"
                          },
                          data: {
                            invoiceId: resInv.taskId,
                            workIds: [this.reBuyObj.id]
                          },
                          store: this.$store
                        }).then(resProd => {
                          this.toggleBodyClass("removeClass", "dynamic-locker");
                          if (resProd != false) {
                            this.$router.push(
                              "/lms/paymentDetail/" + resInv.taskId
                            );
                            //console.log('resProd', resProd);
                          }
                        });
                      }
                    });

                    //#TODO END nehemjleh vvsgeed delgerengui rvv shidne
                  }
                } else {
                  this.$router.push("/");
                }
              });
            }
          }
        }
      });
    }
  }
};
</script>

<style></style>
